import React, { useState } from "react";
import Form from "react-bootstrap/Form";
import { Alert } from "react-bootstrap";
import PropTypes from "prop-types";
import { today } from "../../utils/dateHelpers";
import _Button from "../generic/_Button";
import { useFormikContext } from "formik";
import OptionLabelsSelector from "./OptionLabelsSelector";
import _ModalSaveTemplate from "../modal/campaign/_ModalSaveTemplate";
const Scheduler = (props) => {
  const { isLoading, onValidate, step = null, isRCSForm = false } = props;
  const {
    values,
    handleChange,
    errors,
    handleBlur,
    touched,
    setFieldValue,
    resetForm,
  } = useFormikContext();
  const [openSaveTemplate, setOpenSaveTemplate] = useState({
    data: null,
    visible: false,
  });

  return (
    <div className="bg-white !px-4 !py-2 rounded-lg">
      <div className="flex items-center gap-2 my-2">
        {step && (
          <div className="flex items-center justify-center size-8 rounded-full bg-gray-400 text-white">
            <span className="font-bold">{step}</span>
          </div>
        )}
        <div className="text-xl font-bold text-gray-600">Opciones de Envio</div>
      </div>
      <div className="space-y-4">
        <OptionLabelsSelector
          onChange={(value) => setFieldValue("isScheduled", value)}
          value={values.isScheduled}
          options={[
            {
              value: false,
              label: "Enviar ahora",
            },
            {
              value: true,
              label: "Programar",
            },
          ]}
        />
      </div>
      {values.isScheduled ? (
        <>
          <div className="grid grid-cols-2 gap-4">
            <div className="flex flex-col py-2">
              <label className="text-gray-700 font-semibold text-sm flex justify-start align-top mb-2">
                Fecha de envio:
                <span className="text-red-700 mx-1">*</span>
              </label>
              <Form.Control
                type="date"
                name="dateSend"
                id="dateSend"
                value={values.dateSend}
                today={today()}
                required
                onChange={handleChange}
                placeholder="Fecha de envio"
                onBlur={handleBlur}
                isInvalid={errors && touched.dateSend ? errors.dateSend : ""}
              />
              <Form.Control.Feedback type="invalid">
                {errors.dateSend}
              </Form.Control.Feedback>
            </div>

            <div className="flex flex-col py-2">
              <label className="text-gray-700 font-semibold text-sm flex justify-start align-top mb-2">
                Hora de Envio:
                <span className="text-red-700 mx-1">*</span>
              </label>
              <Form.Control
                type="time"
                name="proghour"
                id="proghour"
                required
                onChange={handleChange}
                value={values.proghour}
                onBlur={handleBlur}
                placeholder="Hora de envio"
                isInvalid={errors && touched.proghour ? errors.proghour : ""}
              />
              <Form.Control.Feedback type="invalid">
                {errors.proghour}
              </Form.Control.Feedback>
            </div>
          </div>
          <div className="grid grid-cols-1 gap-4">
            <div className="flex flex-col py-2">
              <Alert key={"secondary"} variant={"secondary"} className="Notice">
                <b>Nota:</b> Si la hora seleccionada ya transcurrió la campaña
                se ejecutará inmediatamente.
              </Alert>
            </div>
          </div>
        </>
      ) : null}

      <div className="mt-4 flex justify-end">
        <div className="w-full flex gap-2 justify-between">
          {isRCSForm && (
            <_Button
              title="Guardar mensaje como plantilla"
              type="button"
              style="none"
              className="w-full"
              onClick={() =>
                setOpenSaveTemplate({
                  data: values,
                  visible: true,
                })
              }
              loading={isLoading}
            />
          )}
          <_Button
            title="Cancelar"
            type="button"
            style="outline"
            className="w-full"
            onClick={resetForm}
            loading={isLoading}
          />
          <_Button
            title="Enviar"
            type="button"
            style="primary"
            className="w-full"
            onClick={async () => {
              await onValidate();
            }}
            loading={isLoading}
          />
        </div>
      </div>
      <_ModalSaveTemplate
        title="Guardar mensaje como platilla"
        data={openSaveTemplate.data}
        visible={openSaveTemplate.visible}
        onClose={() =>
          setOpenSaveTemplate({
            data: null,
            visible: false,
          })
        }
      />
    </div>
  );
};

Scheduler.propTypes = {
  isLoading: PropTypes.bool,
  onValidate: PropTypes.func,
  step: PropTypes.number,
  isRCSForm: PropTypes.bool,
};

export default Scheduler;
